import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Globe , Plus } from 'lucide-react';

import './Employeetype.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const AddEmployeetype = () => {
    const [submitting, setSubmitting] = useState(false);
    const [data, setData] = useState({
        name: "",
        // code: ""
    });
    const [focusedFields, setFocusedFields] = useState({
        name: false
    });
    const navigate = useNavigate();

    const handleFocus = (field) => {
        setFocusedFields(prev => ({ ...prev, [field]: true }));
    };

    const handleBlur = (field) => {
        setFocusedFields(prev => ({ ...prev, [field]: data[field].length > 0 }));
    };

    const onChangeHandler = (event) => {
        const { name, value } = event.target;
        setData(prevData => ({ ...prevData, [name]: value }));
    };

    const onSubmitHandler = async (event) => {
        event.preventDefault();

        if (!data.name) {
            toast.error("Employeetype name is required");
            return;
        }

        try {
            setSubmitting(true);
            const response = await axios.post(`${url}/api/employeetype`, data);
            
            if (response.data.success) {
                toast.success("Employeetype added successfully!");
                setData({ name: ""});
                navigate('/ViewEmployeetype');
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Failed to add Employeetype";
            toast.error(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="form-wrapper">
           
            <div className="country-form-container">
                <h2 className="form-title">
                    <Globe size={20} className="inline mr-2" /> Add New Employeetype
                </h2>
                 <div className="header">
        <h2></h2>
        <button 
          onClick={() => navigate('/ViewEmployeetype')}
          className="add-button"
        >
          <Plus size={16} /> view Role
        </button>
      </div>
                
                <form className="country-form" onSubmit={onSubmitHandler}>
                    <div className={`form-field ${focusedFields.name || data.name ? 'filled' : ''}`}>
                        <input
                            type="text"
                            name="name"
                            value={data.name}
                            onChange={onChangeHandler}
                            onFocus={() => handleFocus('name')}
                            onBlur={() => handleBlur('name')}
                            required
                        />
                        <label>Employee Type</label>
                    </div>
                    <button 
                        type="submit" 
                        className="submit-btn" 
                        disabled={submitting}
                    >
                        {submitting ? (
                            <span className="flex items-center justify-center">
                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                Processing...
                            </span>
                        ) : "Add Employeetype"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AddEmployeetype;